import type { FeaturesContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: FeaturesContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function FeaturesSection({ content, branding, compact }: Props) {
  const primary = branding?.accentColor || branding?.primaryColor || '#d97706';

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}
      <div className={`grid ${compact ? 'grid-cols-2 gap-2' : 'grid-cols-2 md:grid-cols-3 gap-4'}`}>
        {(content.items || []).map((item, i) => (
          <div
            key={i}
            className={`${compact ? 'p-3' : 'p-5'} rounded-xl transition-all hover:-translate-y-0.5`}
            style={{
              background: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}
          >
            <div
              className={`${compact ? 'w-7 h-7 mb-2' : 'w-10 h-10 mb-3'} rounded-lg flex items-center justify-center`}
              style={{ background: `${primary}12` }}
            >
              <span
                className={`material-icons ${compact ? 'text-sm' : 'text-lg'}`}
                style={{ color: primary }}
              >
                {item.icon || 'star'}
              </span>
            </div>
            <p
              className={`${compact ? 'text-[10px]' : 'text-sm'} font-semibold mb-1`}
              style={{ color: '#292524' }}
            >
              {item.title}
            </p>
            {!compact && item.description && (
              <p className="text-[11px] leading-relaxed" style={{ color: '#a8a29e' }}>
                {item.description}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
